export default __webpack_public_path__ + "locales/ro/ChangeUserTypeDialog.json?hash=a92226f8cd2e3e908f3c9cede5f820b2";